import React from 'react';
import { Form, Input, message, Button, Drawer, Tabs, Table, Upload } from 'antd';
import {
  StyledButton,
  // StyledTable,
  StyledComponent,
  DrawerFooter
  // StyledTabs
} from '../../../commons/styles/layout';
import {
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined
  // DeleteOutlined,
  // QuestionCircleOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { getTranslationCache } from '../../../selectors/language';
// import { tableTranslation } from '../../Adapter/TranslationAdapter';
import themeSettings from '../Utils/themeSettings.json';
import { API_MODULES, IPAddress, API_RUBUSMASTERS } from '../../../commons/api';
import axios from 'axios';
import history from '../../../commons/history';
import localStorage from '../../../utils/localStorage';
import { UpdateMasters, CreateMasters, getSubEquipmentsFileDownloadName } from '../APICalls';

// const { Option } = Select;
const { TabPane } = Tabs;
const APIList = {
  CreateDevices: `${API_MODULES.DevicesCreate}`,
  UpdateDevices: `${API_MODULES.DevicesUpdate}`
};
class SubEquipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formObject: {},
      deviceType: [],
      selectedDeviceType: '',
      onDrawerOpen: false,
      list: []
    };
  }
  hForm = React.createRef();
  componentDidMount() {
    this._getList();
    this.DeviceTypeApi();
    this.getFileDownloadName();
  }

  _getList = () => {
    let path = history.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let url = '';
    url = `/api/rubusMaster/devices/get?SiteId=${siteId}&DeviceType=${path[1]}`;
    let orgHeaders = {
      method: 'GET',
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgHeaders)
      .then((response) => {
        this.setState({ list: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.translationCache !== this.props.translationCache) {
      this.setState({
        translationCache: this.props.translationCache
      });
    }
  };

  translation = (keyword) => {
    let { translationCache } = this.props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          {this.translation('Search')}
        </Button>

        <Button
          onClick={() => this.handleReset(clearFilters, confirm)}
          size="small"
          style={{ width: 90 }}
        >
          {this.translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, fontSize: '130%' }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };
  handleReset = (clearFilters, confirm) => {
    clearFilters();
    this.handleSearch([], confirm);
  };
  _editRecord = (record) => {
    this.hForm.current && this.hForm.current.setFieldsValue(record);
    this.setState({
      formObject: record,
      onDrawerOpen: true
    });
  };

  DeviceTypeApi = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const type = {
      method: '',
      url: `${API_RUBUSMASTERS.DT_GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(type)
      .then((response) => {
        this.setState({
          deviceType: response.data
        });
      })
      .catch(() => {});
  };
  onClose = () => {
    this.hForm.current &&
      this.hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        DeviceType: null,
        DisplayCode: null
      });
    this.setState({ onDrawerOpen: false, formObject: {} });
  };
  openDrawer = () => {
    // e.preventDefault();
    this.hForm.current &&
      this.hForm.current.setFieldsValue({
        Code: null,
        Name: null,
        DeviceType: null,
        DisplayCode: null
      });
    let formObject = {
      Code: null,
      Name: null,
      DeviceType: null,
      DisplayCode: null
    };
    this.setState({
      formObject,
      onDrawerOpen: true
    });
  };
  devicSelection = (value) => {
    this.setState({ selectedDeviceType: value });
  };
  onFinish = async () => {
    let path = history.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    let { formObject } = this.state;
    this.hForm.current &&
      this.hForm.current
        .validateFields()
        .then(async (values) => {
          let payload = {
            ...values,
            DeviceType: path && Array.isArray(path) && path[1] ? path[1] : ''
          };

          if (formObject && formObject.Id) {
            let UpdateResponse = await UpdateMasters(APIList.UpdateDevices, payload, formObject.Id);
            message.success(UpdateResponse && UpdateResponse.message);
          } else {
            let CreateResponse = await CreateMasters(APIList.CreateDevices, payload);
            message.success(CreateResponse && CreateResponse.message);
          }
          this._getList();
          this.getFileDownloadName();
          this.hForm.current &&
            this.hForm.current.setFieldsValue({
              Code: null,
              Name: null,
              DeviceType: null,
              DisplayCode: null
            });
          this.setState({ onDrawerOpen: false, formObject: {} });
        })
        .catch((error) => {
          console.log(error);
        });
  };
  getFileDownloadName = async () => {
    let path = history.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    let fileDownloadName = await getSubEquipmentsFileDownloadName(path[1]);
    this.setState({
      fileDownloadName: fileDownloadName && fileDownloadName.file ? fileDownloadName.file : ''
    });
  };

  render() {
    let {
      formObject,
      onDrawerOpen,
      list,
      fileDownloadName
      // deviceType, selectedDeviceType
    } = this.state;
    const siteId = localStorage.get('currentSite');
    const token = localStorage.get('accessToken');
    var Authorization = 'Bearer ' + token;
    let path = history.location.pathname.split('/rubus/CustomerAssetDevice/DeviceTypesChildren/');
    let colum = [
      { key: 'S No', value: 'S No' },
      { key: 'Sub Equipment Code', value: 'Code' },
      { key: 'Sub Equipment Name', value: 'Name' }
    ];
    let columns =
      colum && Array.isArray(colum)
        ? colum
            // .filter((col) => col !== 'Id' && col !== 'SiteId' && col !== 'AliasCode')
            .map((field) => {
              return {
                title: field.key,
                dataIndex: field.value,
                key: field.value,
                ...this.getColumnSearchProps(field.value)
              };
            })
        : [];
    // let translationTable = tableTranslation(
    //   columns,
    //   this.props.translationCache,
    //   this.props.language
    // );
    let finalColumns = [
      ...columns,
      {
        title: this.translation('Actions'),
        dataIndex: 'Actions',
        key: 'Actions',
        render: (_text, record) => (
          <span>
            <Button
              className="ant-btn"
              icon={<EditOutlined />}
              onClick={() => this._editRecord(record)}
              size="middle"
            />
            {/* <Popconfirm
              title="Are you sure that you want to delete"
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              // onConfirm={() => this.deleteRecord(record.Id)}
              okText="Yes"
              cancelText="No"
            >
              <Button className="ant-btn" size="middle" style={{ marginLeft: '20px' }}>
                <span>
                  {' '}
                  <DeleteOutlined />
                </span>
              </Button>
            </Popconfirm> */}
            {/* <Button type="primary">
              <span>Next</span>
            </Button> */}
          </span>
        )
      }
    ];
    return (
      <StyledComponent
        theme={themeSettings}
        style={{ padding: '0px 30px', minHeight: window.innerHeight - 143 }}
      >
        <div style={{ display: 'flex', justifyContent: 'right', marginTop: '10px' }}>
          <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
            <DownloadOutlined style={{ color: 'white', fontSize: '16px', marginRight: '1px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>
              {this.translation('Download')}{' '}
            </span>
          </a>
          <Upload
            multiple={false}
            style={{ marginRight: '10px', color: 'white' }}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
                this.getFileDownloadName();
                this._getList();
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`/api/rubusMaster/upload/devices?SiteId=${siteId}&DeviceTypeAlias=${path[1]}`}
            headers={{
              Authorization: Authorization
            }}
            showUploadList={false}
          >
            <UploadOutlined style={{ color: 'white', fontSize: '16px', marginRight: '1px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>
              {' '}
              {this.translation('Upload')}
            </span>
          </Upload>
          <StyledButton onClick={(e) => this.openDrawer(e)}>
            <PlusOutlined /> {this.translation('Add SubEquipments')}
          </StyledButton>
        </div>
        <Tabs theme={themeSettings}>
          <TabPane>
            <Table
              className="basictable"
              columns={finalColumns}
              dataSource={list}
              pagination={
                list.length > 10
                  ? {
                      pageSize: '10'
                    }
                  : false
              }
            />
          </TabPane>
        </Tabs>
        <Drawer
          title={
            formObject && formObject.Id
              ? this.translation('Update SubEquipments')
              : this.translation('Add SubEquipments')
          }
          placement="right"
          width={600}
          closable
          onClose={this.onClose}
          visible={onDrawerOpen}
        >
          <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 12 }}
            theme={themeSettings}
            layout="horizontal"
            ref={this.hForm}
            name="Site_form"
            initialValues={formObject}
            onFinish={this.onFinish}
          >
            {/* <Form.Item
              label="DeviceType"
              name="DeviceType"
              rules={[{ required: true, message: 'Please select DeviceType !' }]}
            >
              <Select
                value={selectedDeviceType}
                placeholder="Please select DeviceType"
                onChange={this.devicSelection}
              >
                {deviceType.map((value, index) => {
                  return (
                    <Option key={index} value={value.Code}>
                      {value.DisplayCode}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item> */}
            <Form.Item
              label={this.translation('Code')}
              name="Code"
              rules={[{ required: true, message: 'Please select Code !' }]}
            >
              <Input disabled={formObject && formObject.Id ? true : false} />
            </Form.Item>
            <Form.Item
              label={this.translation('Name')}
              name="Name"
              rules={[{ required: true, message: 'Please select Name !' }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label={this.translation('DisplayCode')}
              name="DisplayCode"
              rules={[{ required: true, message: 'Please enter DisplayCode' }]}
            >
              <Input />
            </Form.Item>
          </Form>
          <DrawerFooter>
            <Button onClick={this.onClose} style={{ marginRight: 8 }}>
              {this.translation('Cancel')}
            </Button>
            <Button type="primary" onClick={this.onFinish}>
              {this.translation('Submit')}
            </Button>
          </DrawerFooter>
        </Drawer>
      </StyledComponent>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache()
});

export default connect(mapStateToProps)(SubEquipments);
